import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { type CommonQueryArgs, DAAS_COLLECTION_OWNERS_COUNT } from '@pkg/hooks';

import { type UnifiedCollectionFormat } from '@app/client';
import { callGetCollectionOwnership } from '@app/client/resources/daas';

interface GetCollectionOwnersArgs extends CommonQueryArgs {
    slugQuery: UnifiedCollectionFormat;
    countOnly?: boolean;
}
export function useGetCollectionOwners({ slugQuery, countOnly, disabled, limit = 100 }: GetCollectionOwnersArgs) {
    const sharedOptions = {
        retry: false,
        placeholderData: keepPreviousData,
        enabled: Boolean(slugQuery) && !disabled,
    };
    const { data: countData, ...rest } = useQuery({
        queryKey: [DAAS_COLLECTION_OWNERS_COUNT, slugQuery, countOnly],
        queryFn: ({ signal }) =>
            callGetCollectionOwnership({
                settings: { signal },
                query: { slug: slugQuery, count_only: countOnly },
            }),
        ...sharedOptions,
        enabled: sharedOptions.enabled && !!countOnly,
    });

    const { data: walletData } = useInfiniteQuery({
        queryKey: [DAAS_COLLECTION_OWNERS_COUNT, slugQuery, countOnly, 'infinite'],
        queryFn: ({ signal, pageParam }) =>
            callGetCollectionOwnership({
                settings: { signal },
                query: {
                    count_only: countOnly,
                    limit,
                    slug: slugQuery,
                    ...(pageParam ? { continuation: pageParam } : {}),
                },
            }),
        ...sharedOptions,
        enabled: sharedOptions.enabled && !countOnly,
        initialPageParam: '',
        getNextPageParam: (params) => params.continuation,
    });

    return { countData, walletData, ...rest };
}
